<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-text>
              <v-row justify="start" class="pa-2">
                <div>
                  <v-text-field :readonly="emailReadOnly" @click:clear="onClearEmailAddress" clearable width="400"
                    v-model="emailAddress" label="Email Address" variant="outlined"></v-text-field>
                </div>
                <v-btn v-if="canLinkEmailAddress == false" class="ml-2" @click="getSuperDistiLinkedList" icon="mdi-magnify" size="large"
                  variant="text"></v-btn>
                <v-btn class="ml-2" v-if="canLinkEmailAddress" @click="clickLinkDistributor" variant="text" icon="mdi-plus" size="large"></v-btn>
              </v-row>
              <v-row v-if="canLinkEmailAddress" justify="start" class="pa-2">
                <v-col cols="12" md="6">
                  <v-sheet color="transparent">
                    Linked Distributors {{ superDisti.superDistiRoleItems.length }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row v-if="canLinkEmailAddress === true">
                <v-col cols="12" >
                  <v-data-table items-per-page="50" :headers="headersDistributors"
                    :items="superDisti.superDistiRoleItems" item-key="id"
                    class="v-data-table">
                    <template v-slot:item.linkDistributor="{ item }">
                      <v-btn size="small" icon="mdi-minus" @click="superDistiRemoveLink(item.id)"></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer v-model="showDistributorsPanel" location="right" :width="500">
      <v-container>
        <v-text-field variant="outlined" v-model="searchDistributor" label="Search" prepend-inner-icon="mdi-magnify"
          clearable></v-text-field>
        <v-data-table items-per-page="50" :headers="headersDistributors" :items="distributors.distributors"
          item-key="id" :search="searchDistributor" class="v-data-table">
          <template v-slot:item.linkDistributor="{ item }">            
            <v-btn v-if="item.alreadyLinked === false"  size="small" icon="mdi-plus" @click="superDistiAddLink(item)"></v-btn>
          </template>
        </v-data-table>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useDistributorStore } from '@/stores/distributor'

const distributorStore = useDistributorStore()

const showLinkEmailDialog = ref(false)
const showDistributorsPanel = ref(false)
const distributors = ref({
  distributors: []
})
const searchDistributor = ref('')
const emailAddress = ref('')
const superDisti = ref({
  superDistiRoleItems: []
})
const canLinkEmailAddress = ref(false)
const emailReadOnly = ref(false)
const selectedDistributor = ref(null)

const headersDistributors = [
  { key: 'affinityId', title: 'Affinity Id', align: 'start', sortable: true },
  { key: 'accountName', title: 'Distributor', align: 'end', sortable: true },
  { key: 'country', title: 'Country', align: 'end', sortable: true },
  { title: '', value: 'linkDistributor', width: 25, sortable: false },
]

const filteredDistributors = computed(() => {
  return distributors.value.distributors.filter((distributor) => {
    return distributor.accountName.toLowerCase().includes(searchDistributor.value.toLowerCase())
  })
})
const getDistributors = async () => {
  distributors.value = await distributorStore.getDistributors(emailAddress.value)
}

const getSuperDistiLinkedList = async () => {
  if (emailAddress.value.length < 3) {
    return
  }

  superDisti.value = await distributorStore.getSuperDistiLinkedList(emailAddress.value)
  emailReadOnly.value = true
  canLinkEmailAddress.value = true
}

const superDistiAddLink = async (item) => {
  await distributorStore.superDistiAddLink(emailAddress.value, item.affinityId, item.accountName, item.country)
  await getSuperDistiLinkedList()
  await getDistributors()
}

const superDistiRemoveLink = async (userAffinityId) => {
  await distributorStore.superDistiRemoveLink(userAffinityId)
  await getSuperDistiLinkedList()
  await getDistributors()
}

const clickLinkDistributor = async () => {
  
  showDistributorsPanel.value = !showDistributorsPanel.value

  if (showDistributorsPanel.value) {
    await getDistributors()
  }
}
const onClearEmailAddress = () => {
  emailAddress.value = ''
  emailReadOnly.value = false
  canLinkEmailAddress.value = false
  showDistributorsPanel.value = false
  superDisti.value.superDistiRoleItems = []
  distributors.value = []
}

</script>